import {isRangeInlineJSON} from "./RangeInlineJSON";
import {isTreeInlineJSON} from "./TreeInlineJSON";

export function isInlineNode(possibleInlineContent): possibleInlineContent is InlineNode {
  return typeof possibleInlineContent === "string"
    || isTreeInlineJSON(possibleInlineContent)
    || isRangeInlineJSON(possibleInlineContent);
}
